module.exports = __webpack_public_path__ + "img/ic-forward.aa9b62fe.svg";